export default "__VITE_ASSET__aKL29Hwl__"